import {ContentTypes, getApi} from "../../common/actions/net.js";

import Logger from "../../common/util/Logger.js";
import {makeApiUrl} from "../../common/util/config.jsx";

export const PRODUCT_IMAGE_IS_LOADING = "PRODUCT_IMAGE_IS_LOADING";
export const PRODUCT_IMAGE_DONE_LOADING = "PRODUCT_IMAGE_DONE_LOADING";
export const PRODUCT_IMAGE_FAILED_LOADING = "PRODUCT_IMAGE_FAILED_LOADING";


const setPrdImgIsLoading = (productId) => ({
    type: PRODUCT_IMAGE_IS_LOADING,
    productId: productId,
});
const setPrdImgDoneLoading = (productId, imageUrl) => ({
    type: PRODUCT_IMAGE_DONE_LOADING,
    productId: productId,
    imageUrl: imageUrl,
});
const setPrdImgFailedLoading = (productId) => ({
    type: PRODUCT_IMAGE_FAILED_LOADING,
    productId: productId,
});

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
};

/**
 * Downloads image for the product if needed, and does a callback with imageUrl as parameter.
 * @param {object} productImage 
 * @param {number} productId
 * @param {string} imageName
 * @param {func} callback
 * @returns {func}
 */
export function loadProductImage(productImage, productId, imageName, callback){
    return async (dispatch) => {
        let isLoading = false;
        let imageUrl;
        try {
            //is product image beeing worked on
            if( productImage[productId] ) {
                //give the worker up to 30s to download the image
                for(let i=0; i<300 && productImage[productId].loading; i++) {
                    await sleep(100);//100ms
                }
                //check if we timed out
                if( productImage[productId].loading ){
                    dispatch( setPrdImgFailedLoading() );
                }
                //
                callback(productImage[productId].imageUrl);
            }
            //if no work has been started
            else {
                isLoading = true;
                dispatch( setPrdImgIsLoading(productId) );

                imageUrl = await dispatch(getApi("Product/GetProductImage", {productId, imageName}, ContentTypes.JSON, ContentTypes.IMAGE));

                dispatch( setPrdImgDoneLoading(productId, imageUrl) );

                callback(imageUrl);
            }
        } catch (error) {
            if( isLoading ) {
                dispatch( setPrdImgFailedLoading(productId) );
            }
            callback(imageUrl);
            Logger.error(error);
        }
    };
}

/**
 * Returns an image only if it is downloaded
 * @param {number} productId
 * @returns {func}
 */
export function getExistingProductImage(productId){
    return makeApiUrl(`Product/GetProductImage?ProductId=${productId}&ImageName=${productId}.png`);
}